import styled from 'styled-components';

export const SizeContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
`;
export const ChartRow = styled.div`
  display: flex;
  background-color: ${(props) => (props.heading ? '#acf3ac' : '#fff')};
  width: ${(props) => (props.skeleton ? '64%' : 'inherit')};
  align-items: center;
  justify-content: flex-start;
  width: 90%;
  margin: auto;
  flex-wrap: wrap;
`;
export const ChartData = styled.div`
  padding: 16px 15px;
  // width: 50px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  height: 50px;
  align-items: center;
  font-size: 14px;
  margin: 2px 6px;
  display: flex;
  border-radius: 5px;
  justify-content: center;
  p {
    &.disabled {
      opacity: 0.3;
    }
  }
  &.active {
    border: solid 1px #ef4e5e;
    background-color: #fdecec;
  }
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const LineThrough = styled.span`
  display: none;
  border-top: 1px solid black;
  width: 50px;
  position: absolute;
  transform: rotate(43deg);
  opacity: 0.3;
  &.disabled {
    display: block;
  }
`;
